module.exports = __webpack_public_path__ + "static/turquia-027.thumb-2c2ce3f9e255d4a7974c931f8990634a.jpg";